import { RewardType } from "../../domain/enums/RewardType";
import { MemberAccount } from "../../domain/models/MemberAccount";
import { Reward } from "../../domain/models/Reward"
import './MemberRewardCard.css';

export interface MemberRewardCardProps {
  memberAccount: MemberAccount;
  reward: Reward;
  onExchange?: (reward: Reward) => void;
}

export const MemberRewardCard = ({
  memberAccount,
  reward,
  onExchange
}: MemberRewardCardProps) => {

  const memberAccountPointsBalance = memberAccount.pointsBalance || 0;
  const rewardPointsRequired = reward.pointsRequired || 0;
  const hasPointsRequired = memberAccountPointsBalance >= rewardPointsRequired;
  const typeName = reward.type == RewardType.PercentageDiscountCoupon || reward.type == RewardType.ValueDiscountCoupon
    ? 'resgatar'
    : 'recompensa de';
  const rewardName = reward.name?.replaceAll('cupom ', '');

  if (hasPointsRequired) {
    return (
      <button key={`reward-${reward.id}`} className='member-reward-card--exchangeable'
        onClick={() => onExchange && onExchange(reward) }
      >
        <div style={{ marginBottom: '0.2rem', fontSize: '0.9em'}}>
          {typeName}
        </div>
        <div style={{ marginBottom: '1rem', fontSize: '1.1em' }}>
          {rewardName}
        </div>
        <div style={{ fontSize: '0.8em' }}>
          {reward.pointsRequired} pts
        </div>
      </button>
    )
  }

  return (
    <div key={`reward-${reward.id}`} className='member-reward-card--non-exchangeable'
      title='O cliente não possui pontos suficientes para resgatar esta recompensa.'
    >
      <div style={{ marginBottom: '0.2rem', fontSize: '0.9em' }}>
        {typeName}
      </div>
      <div style={{ marginBottom: '1rem', fontSize: '1.1em' }}>
        {rewardName}
      </div>
      <div style={{ fontSize: '0.8em' }}>
        {reward.pointsRequired} pts
      </div>
    </div>
  )
}